import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormularioImplantacao, ImplantacoesService, VagaImplantacao} from '../../services/implantacoes.service';

@Component({
  selector: 'app-formulario-implantacao',
  templateUrl: './formulario-implantacao.component.html',
  styleUrls: ['./formulario-implantacao.component.scss']
})
export class FormularioImplantacaoComponent implements OnInit {
  readonly fusoOperacional = 'America/Sao_Paulo';
  readonly dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  readonly modalidades = [{valor: 'DELIVERY', nome: 'Entrega'}, {valor: 'RETIRADA', nome: 'Retirada'}, {valor: 'LOCAL', nome: 'Consumo no local'}];
  readonly pagamentos = ['Dinheiro', 'Pix', 'Débito', 'Crédito', 'Vale-refeição', 'Pagamento online'];
  readonly tiposFidelidade = [{valor: 'SELOS', nome: 'Selos'}, {valor: 'PONTOS', nome: 'Pontos'}, {valor: 'CASHBACK', nome: 'Cashback'}];
  token = '';
  passo = 0;
  resumo: any = null;
  dados: FormularioImplantacao = this.dadosVazios();
  anexos: any[] = [];
  carregando = true;
  salvando = false;
  enviandoArquivo = false;
  enviado = false;
  usaIntegracao = false;
  erro = '';
  aviso = '';
  dataVagas = '';
  vagas: VagaImplantacao[] = [];
  vaga: VagaImplantacao | null = null;
  reservando = false;
  private consultaVagasSeq = 0;
  private uploadsPendentes = 0;

  constructor(private route: ActivatedRoute, public api: ImplantacoesService) {}

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    this.carregue();
  }

  dadosVazios(): FormularioImplantacao {
    return {
      nomeEmpresa: '', responsavelNome: '', responsavelWhatsapp: '', whatsappLoja: '',
      endereco: {cep: '', logradouro: '', bairro: '', cidade: '', uf: ''},
      fusoHorario: 'America/Sao_Paulo', horarios: [], modalidades: [], formasPagamento: [],
      arquivosCardapio: [], mesasQr: false, fidelidade: {tipos: []}, entrega: {area: '', taxa: '', prazo: ''}
    };
  }

  carregue() {
    this.carregando = true;
    this.erro = '';
    this.api.publicaObtenha(this.token).then(resumo => {
      this.resumo = resumo;
      const salvos = resumo.formulario?.dados || resumo.dados || {};
      this.dados = {...this.dadosVazios(), ...salvos,
        endereco: {...this.dadosVazios().endereco, ...(salvos.endereco || {})},
        horarios: salvos.horarios || [], modalidades: salvos.modalidades || [],
        formasPagamento: salvos.formasPagamento || [], arquivosCardapio: salvos.arquivosCardapio || [],
        fidelidade: {tipos: [], ...(salvos.fidelidade || {})},
        entrega: {area: '', taxa: '', prazo: '', ...(salvos.entrega || {})}};
      if (!this.dados.nomeEmpresa) { this.dados.nomeEmpresa = resumo.empresa?.nome || resumo.nomeEmpresa || ''; }
      this.usaIntegracao = !!this.dados.integracao;
      this.anexos = resumo.formulario?.anexos || resumo.anexos || [];
      const idsCardapio = this.anexos.filter(anexo => anexo.tipo === 'CARDAPIO').map(anexo => Number(anexo.id)).filter(Boolean);
      this.dados.arquivosCardapio = Array.from(new Set(this.dados.arquivosCardapio.concat(idsCardapio)));
      this.enviado = (resumo.formulario?.status || resumo.status) === 'SUBMETIDO';
      this.dataVagas = this.diaOperacional(resumo.dataMinimaTreinamento) || this.diaOperacional(new Date().toISOString());
      if (this.enviado) { this.passo = 5; }
    }).catch(erro => this.erro = String(erro || 'Link inválido ou indisponível.'))
      .finally(() => this.carregando = false);
  }

  diaOperacional(valor: string | null | undefined): string {
    if (!valor) { return ''; }
    const partes = new Intl.DateTimeFormat('en-US', {timeZone: this.fusoOperacional, year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date(valor));
    const v = (tipo: string) => partes.find(parte => parte.type === tipo)?.value || '';
    return `${v('year')}-${v('month')}-${v('day')}`;
  }

  hora(valor: string): string {
    return new Intl.DateTimeFormat('pt-BR', {timeZone: this.fusoOperacional, hour: '2-digit', minute: '2-digit'}).format(new Date(valor));
  }

  dataHora(valor: string): string {
    return new Intl.DateTimeFormat('pt-BR', {timeZone: this.fusoOperacional, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'}).format(new Date(valor));
  }

  dataHoraCliente(valor: string): string {
    try { return new Intl.DateTimeFormat('pt-BR', {timeZone: this.dados.fusoHorario || this.fusoOperacional, day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(valor)); }
    catch (_) { return this.dataHora(valor); }
  }

  inclui(lista: string[], valor: string): boolean { return (lista || []).includes(valor); }
  altereLista(lista: string[], valor: string, marcado: boolean) {
    const indice = lista.indexOf(valor);
    if (marcado && indice < 0) { lista.push(valor); }
    if (!marcado && indice >= 0) { lista.splice(indice, 1); }
  }

  incluiDia(dia: number): boolean { return this.dados.horarios.some(horario => Number(horario.diaSemana) === dia); }
  altereDia(dia: number, marcado: boolean) {
    if (marcado && !this.incluiDia(dia)) { this.dados.horarios.push({diaSemana: dia, abre: '09:00', fecha: '18:00'}); }
    if (!marcado) { this.dados.horarios = this.dados.horarios.filter(horario => Number(horario.diaSemana) !== dia); }
  }

  adicioneHorario(dia: number) { this.dados.horarios.push({diaSemana: dia, abre: '09:00', fecha: '18:00'}); }
  removaHorario(indice: number) { this.dados.horarios.splice(indice, 1); }
  altereIntegracao(marcado: boolean) { this.usaIntegracao = marcado; if (!marcado) { this.dados.integracao = ''; } }

  proximo() { this.erro = ''; this.passo = Math.min(4, this.passo + 1); window.scrollTo(0, 0); }
  anterior() { this.erro = ''; this.passo = Math.max(0, this.passo - 1); window.scrollTo(0, 0); }

  async salve(enviar: boolean) {
    if (enviar && this.dados.linkIfood?.trim()) {
      try {
        const link = new URL(this.dados.linkIfood.trim());
        if (!['http:', 'https:'].includes(link.protocol) || !link.hostname) { throw new Error('URL inválida'); }
      } catch (_) {
        this.erro = 'Informe um link HTTP(S) válido para o iFood.';
        this.passo = 2;
        return;
      }
    }
    if (enviar && !this.dados.cardapioUrl?.trim() && !this.dados.arquivosCardapio.length) {
      this.erro = 'Informe um link ou envie um arquivo de cardápio. Seus dados continuam disponíveis para salvar como rascunho.';
      this.passo = 2;
      return;
    }
    if (this.enviandoArquivo) { this.erro = 'Aguarde o envio dos arquivos terminar.'; return; }
    this.salvando = true;
    this.erro = '';
    this.aviso = '';
    try {
      const resposta = await this.api.publiqueFormulario(this.token, this.dados, enviar);
      this.resumo = {...this.resumo, ...(resposta || {})};
      if (enviar) {
        this.enviado = true; this.passo = 5;
        try {
          const atualizado = await this.api.publicaObtenha(this.token);
          this.resumo = {...this.resumo, ...atualizado};
        } catch (_) { /* A submissão já foi confirmada; mantém os prazos recebidos no PUT. */ }
        this.dataVagas = this.diaOperacional(this.resumo.dataMinimaTreinamento) || this.dataVagas;
      }
      this.aviso = enviar ? 'Formulário enviado. Agora você pode escolher sua reunião.' : 'Rascunho salvo. Você pode voltar pelo mesmo link.';
    } catch (erro) {
      this.erro = String(erro || 'Não foi possível salvar. Confira os campos e tente novamente.');
      // Não descartar o formulário: a resposta do servidor pode apontar um campo a corrigir.
    } finally { this.salvando = false; }
  }

  async envieAnexos(entrada: HTMLInputElement, tipo: string) {
    const arquivos = Array.from(entrada.files || []);
    if (!arquivos.length) { return; }
    this.enviandoArquivo = ++this.uploadsPendentes > 0;
    this.erro = '';
    try {
      const resposta = await this.api.publiqueAnexos(this.token, arquivos, tipo);
      const novos = Array.isArray(resposta) ? resposta : resposta?.anexos || (resposta?.id ? [resposta] : []);
      this.anexos = this.anexos.concat(novos);
      if (tipo === 'CARDAPIO') {
        this.dados.arquivosCardapio = Array.from(new Set(this.dados.arquivosCardapio.concat(novos.map((anexo: any) => Number(anexo.id)).filter(Boolean))));
      }
      this.aviso = `${arquivos.length} arquivo(s) enviado(s). Salve o rascunho para preservar as respostas.`;
    } catch (erro) { this.erro = String(erro || 'Falha no upload. Tente novamente.'); }
    finally { entrada.value = ''; this.enviandoArquivo = --this.uploadsPendentes > 0; }
  }

  invalideVagas() { this.consultaVagasSeq++; this.vaga = null; this.vagas = []; }

  async consulteVagas(): Promise<void> {
    this.invalideVagas();
    const sequencia = this.consultaVagasSeq;
    const data = this.dataVagas;
    this.erro = '';
    if (!data) { this.erro = 'Escolha uma data para consultar vagas.'; return; }
    try {
      const vagas = await this.api.vagasPublicas(this.token, data);
      if (sequencia === this.consultaVagasSeq && data === this.dataVagas) { this.vagas = vagas || []; }
    } catch (erro) {
      if (sequencia === this.consultaVagasSeq && data === this.dataVagas) {
        this.vagas = [];
        this.erro = String(erro || 'Não foi possível consultar horários.');
      }
    }
  }

  async reserve() {
    if (!this.vaga) { return; }
    this.reservando = true;
    this.erro = '';
    try {
      const resposta = await this.api.reservaPublica(this.token, this.vaga.implantador.id, this.vaga.inicio);
      this.resumo = {...this.resumo, ...(resposta || {})};
      this.aviso = 'Reunião reservada. Guarde o horário exibido abaixo.';
      this.vagas = [];
    } catch (erro) {
      const mensagem = String(erro || 'Este horário não está mais disponível. Consulte as vagas novamente.');
      await this.consulteVagas();
      this.erro = mensagem;
    } finally { this.reservando = false; }
  }
}
